// src/container/Mantenimiento/MantenimientoGate.jsx
// Si MODO_MANTENIMIENTO está activo, muestra una pantalla de "en
// mantenimiento" al público. Escribiendo la PALABRA_SECRETA con el teclado
// (sin hacer clic en nada antes) se desbloquea la web normal para quien la
// escriba; queda guardado en ese navegador (localStorage), así no hace
// falta repetirlo cada vez.
import { useEffect, useState } from "react";
import { MODO_MANTENIMIENTO, PALABRA_SECRETA } from "../../constants/mantenimiento";

const STORAGE_KEY = "ua_bypass_mantenimiento";

const PantallaMantenimiento = ({ onDesbloqueado }) => {
  useEffect(() => {
    let buffer = "";

    const onKeyDown = (e) => {
      if (e.key.length !== 1) return; // ignora Shift, Enter, flechas, etc.
      buffer = (buffer + e.key).slice(-PALABRA_SECRETA.length).toLowerCase();
      if (buffer === PALABRA_SECRETA.toLowerCase()) {
        localStorage.setItem(STORAGE_KEY, "true");
        onDesbloqueado();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onDesbloqueado]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "2rem",
        background:
          "radial-gradient(circle at 50% 30%, #1a1a1a 0%, #000000 70%)",
        color: "#f8fafc",
      }}
    >
      <img
        src="/img/escudo.png"
        alt="U.A. Ceutí"
        style={{ width: 96, height: "auto", marginBottom: "1.5rem" }}
      />
      <h1 style={{ fontSize: "1.75rem", fontWeight: 700, marginBottom: "0.75rem" }}>
        Web en mantenimiento
      </h1>
      <p style={{ color: "#94a3b8", maxWidth: 360 }}>
        Estamos preparando cosas nuevas. Vuelve a pasarte pronto.
      </p>
    </div>
  );
};

const MantenimientoGate = ({ children }) => {
  const [desbloqueado, setDesbloqueado] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true"
  );

  if (!MODO_MANTENIMIENTO || desbloqueado) {
    return children;
  }

  return <PantallaMantenimiento onDesbloqueado={() => setDesbloqueado(true)} />;
};

export default MantenimientoGate;
